import { IExtendedRealtimeCameraInfo } from './models/realtime-event-response.model'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

export enum RealtimeEventStatus {
  CONCLUDED = 'CONCLUDED',
  INTERMISSION = 'INTERMISSION',
  LIVE = 'LIVE',
  PRE_AIR = 'PREAIR'
}

export const filterSortStreams = (streams: ReadonlyArray<IExtendedRealtimeCameraInfo>) =>
  streams.filter(a => a.isActive).sort((a, b) => a.sortOrder - b.sortOrder)

export const filterSortStreamObs = (source: Observable<ReadonlyArray<IExtendedRealtimeCameraInfo>>) =>
  source.pipe(map(filterSortStreams))
